var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-panel__header p-2"},[_c('h3',{staticClass:"my-0"},[(_vm.$slots.default)?_vm._t("default"):[_vm._v(" Actions ")]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }